var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/Button/Button.tsx
import { jsx } from "react/jsx-runtime";
var Button = (_a) => {
  var _b = _a, {
    primary = false,
    size = "medium",
    backgroundColor,
    label
  } = _b, props = __objRest(_b, [
    "primary",
    "size",
    "backgroundColor",
    "label"
  ]);
  const mode = primary ? "storybook-button--primary" : "storybook-button--secondary";
  return /* @__PURE__ */ jsx(
    "button",
    __spreadProps(__spreadValues({
      type: "button",
      className: ["storybook-button", `storybook-button--${size}`, mode].join(
        " "
      ),
      style: { backgroundColor }
    }, props), {
      children: label
    })
  );
};

// src/components/GafaelfawrUserDropdown/GafaelfawrUserDropdown.tsx
import styled4 from "styled-components";

// src/components/GafaelfawrUserDropdown/Menu.tsx
import styled3 from "styled-components";
import * as RadixDropdownMenu2 from "@radix-ui/react-dropdown-menu";
import { ChevronDown } from "react-feather";

// src/components/GafaelfawrUserDropdown/MenuItem.tsx
import React from "react";
import styled from "styled-components";
import { DropdownMenuItem } from "@radix-ui/react-dropdown-menu";
import { jsx as jsx2 } from "react/jsx-runtime";
var MenuItem = React.forwardRef((props, forwardedRef) => /* @__PURE__ */ jsx2(StyledDropdownMenuItem, __spreadProps(__spreadValues({}, props), { ref: forwardedRef, children: props.children })));
MenuItem.displayName = "MenuItem";
var StyledDropdownMenuItem = styled(DropdownMenuItem)`
  color: var(--rsd-component-header-nav-menulist-text-color);
  border-radius: 0.5rem;
  padding: calc(var(--gafaelfawr-user-menu-padding) / 2)
    var(--gafaelfawr-user-menu-padding);
  margin: calc(var(--gafaelfawr-user-menu-padding) / -2);
  margin-bottom: calc(var(--gafaelfawr-user-menu-padding) / 2);
  &:last-of-type {
    margin-bottom: 0;
  }

  outline: none;

  &:focus {
    background-color: var(
      --rsd-component-header-nav-menulist-selected-background-color
    );
    color: white;

    a {
      color: white;
    }
  }
`;
var MenuItem_default = MenuItem;

// src/components/GafaelfawrUserDropdown/Separator.tsx
import styled2 from "styled-components";
import * as RadixDropdownMenu from "@radix-ui/react-dropdown-menu";
var Separator2 = styled2(RadixDropdownMenu.Separator)`
  margin: 0.5rem calc(var(--gafaelfawr-user-menu-padding) * -1) 0.5rem;
  border: 1px solid var(--rsd-color-primary-700);
`;
var Separator_default = Separator2;

// src/components/GafaelfawrUserDropdown/Menu.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var Menu = ({ children, logoutHref, username }) => {
  return /* @__PURE__ */ jsxs(RadixDropdownMenu2.Root, { children: [
    /* @__PURE__ */ jsx3(RadixDropdownMenu2.Trigger, { asChild: true, children: /* @__PURE__ */ jsxs(MenuTriggerButton, { children: [
      username,
      " ",
      /* @__PURE__ */ jsx3(ChevronDown, {})
    ] }) }),
    /* @__PURE__ */ jsx3(RadixDropdownMenu2.Portal, { children: /* @__PURE__ */ jsxs(StyledContent, { align: "end", sideOffset: 5, children: [
      children,
      /* @__PURE__ */ jsx3(Separator_default, {}),
      /* @__PURE__ */ jsx3(MenuItem_default, { children: /* @__PURE__ */ jsx3("a", { href: logoutHref, children: "Log out" }) }),
      /* @__PURE__ */ jsx3(RadixDropdownMenu2.Arrow, { className: "DropdownMenuArrow" })
    ] }) })
  ] });
};
var MenuTriggerButton = styled3.button`
  background-color: transparent;
  color: var(--rsd-component-header-nav-text-color);
  border: 1px solid transparent;
  border-radius: 0.25rem;

  &:focus {
    outline: 1px solid var(--rsd-color-primary-500);
  }

  &:hover {
    color: var(--rsd-component-header-nav-text-hover-color);
  }

  svg {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    vertical-align: middle;
  }

  &[data-state='open'] {
    svg {
      transform: rotate(180deg);
    }
  }
`;
var StyledContent = styled3(RadixDropdownMenu2.Content)`
  /* This unit for the padding is also the basis for the spacing and
   * sizing of the menu items.
  */
  --gafaelfawr-user-menu-padding: 0.5rem;

  font-size: 1rem;
  background-color: var(--rsd-component-header-nav-menulist-background-color);
  min-width: 12rem;
  border-radius: 0.5rem;
  padding: var(--gafaelfawr-user-menu-padding);
  color: var(--rsd-component-header-nav-menulist-text-color);
  box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35),
    0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;

  a {
    color: var(--rsd-component-header-nav-menulist-text-color);
  }

  .DropdownMenuArrow {
    fill: var(--rsd-component-header-nav-menulist-background-color);
  }
`;
var Menu_default = Menu;

// src/components/GafaelfawrUserDropdown/authUrls.ts
function getLoginUrl(currentUrl) {
  const loginUrl = new URL("/login", currentUrl);
  const url = new URL(currentUrl);
  loginUrl.searchParams.append("rd", url.href);
  return loginUrl.href;
}
function getLogoutUrl(currentUrl) {
  const logoutUrl = new URL("/logout", currentUrl);
  const homeUrl = new URL("/", currentUrl);
  logoutUrl.searchParams.append("rd", homeUrl.href);
  return logoutUrl.href;
}

// src/hooks/useGafaelfawrUser.ts
import useSWR from "swr";
import fetch from "unfetch";
var fetcher = (url) => fetch(url).then((res) => res.json());
var useGafaelfawrUser = () => {
  const { data, error, isLoading, isValidating } = useSWR(
    "/auth/api/v1/user-info",
    fetcher
  );
  const isLoggedIn = !error && data && data.hasOwnProperty("username");
  return {
    user: data,
    isLoading,
    isValidating,
    isLoggedIn,
    error
  };
};
var useGafaelfawrUser_default = useGafaelfawrUser;

// src/components/GafaelfawrUserDropdown/GafaelfawrUserDropdown.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var GafaelfawrUserDropdown = ({
  children,
  currentUrl
}) => {
  const { user, isLoggedIn } = useGafaelfawrUser_default();
  const logoutUrl = getLogoutUrl(currentUrl);
  const loginUrl = getLoginUrl(currentUrl);
  if (isLoggedIn && user) {
    return /* @__PURE__ */ jsx4(Menu_default, { logoutHref: logoutUrl, username: user.username, children });
  } else {
    return /* @__PURE__ */ jsx4(SiteNavLink, { href: loginUrl, children: "Log in / Sign up" });
  }
};
var SiteNavLink = styled4.a`
  color: var(--rsd-component-header-nav-text-color);

  &:hover {
    color: var(--rsd-component-header-nav-text-hover-color);
  }
`;
GafaelfawrUserDropdown.Item = MenuItem_default;
GafaelfawrUserDropdown.Separator = Separator_default;
var GafaelfawrUserDropdown_default = GafaelfawrUserDropdown;

// src/components/GafaelfawrUserMenu/GafaelfawrUserMenu.tsx
import styled6 from "styled-components";

// src/lib/authUrls.ts
function getLoginUrl2(currentUrl) {
  const loginUrl = new URL("/login", currentUrl);
  const url = new URL(currentUrl);
  loginUrl.searchParams.append("rd", url.href);
  return loginUrl.href;
}
function getLogoutUrl2(currentUrl) {
  const logoutUrl = new URL("/logout", currentUrl);
  const homeUrl = new URL("/", currentUrl);
  logoutUrl.searchParams.append("rd", homeUrl.href);
  return logoutUrl.href;
}

// src/components/GafaelfawrUserMenu/Menu.tsx
import styled5 from "styled-components";
import { ChevronDown as ChevronDown2 } from "react-feather";
import * as RadixNavigationMenu from "@radix-ui/react-navigation-menu";
import { jsx as jsx5, jsxs as jsxs2 } from "react/jsx-runtime";
var Menu2 = ({ children, logoutHref, username }) => {
  return /* @__PURE__ */ jsxs2(MenuRoot, { children: [
    /* @__PURE__ */ jsx5(MenuList, { children: /* @__PURE__ */ jsxs2(RadixNavigationMenu.Item, { children: [
      /* @__PURE__ */ jsxs2(
        MenuTrigger,
        {
          onPointerMove: (event) => event.preventDefault(),
          onPointerEnter: (event) => event.preventDefault(),
          onPointerLeave: (event) => event.preventDefault(),
          children: [
            username,
            " ",
            /* @__PURE__ */ jsx5(ChevronDown2, {})
          ]
        }
      ),
      /* @__PURE__ */ jsxs2(
        MenuContent,
        {
          onPointerMove: (event) => event.preventDefault(),
          onPointerEnter: (event) => event.preventDefault(),
          onPointerLeave: (event) => event.preventDefault(),
          children: [
            children,
            /* @__PURE__ */ jsx5(MenuLink, { href: logoutHref, children: "Log out" })
          ]
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx5(ViewportContainer, { children: /* @__PURE__ */ jsx5(
      ContentViewport,
      {
        onPointerEnter: (event) => event.preventDefault(),
        onPointerLeave: (event) => event.preventDefault()
      }
    ) })
  ] });
};
var MenuRoot = styled5(RadixNavigationMenu.Root)``;
var MenuList = styled5(RadixNavigationMenu.List)`
  list-style: none;
  margin-bottom: 0;
`;
var MenuTrigger = styled5(RadixNavigationMenu.Trigger)`
  background-color: transparent;
  color: var(--rsd-component-header-nav-text-color);
  border: 1px solid transparent;
  border-radius: 0.25rem;

  &:focus {
    outline: 1px solid var(--rsd-color-primary-500);
  }

  &:hover {
    color: var(--rsd-component-header-nav-text-hover-color);
  }

  svg {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    vertical-align: middle;
  }

  &[data-state='open'] {
    svg {
      transform: rotate(180deg);
    }
  }
`;
var MenuContent = styled5(RadixNavigationMenu.Content)`
  /* This unit for the padding is also the basis for the spacing and
   * sizing of the menu items.
  */
  --gafaelfawr-user-menu-padding: 0.5rem;

  display: flex;
  flex-direction: column;
  gap: var(0.25rem);

  font-size: 1rem;
  background-color: var(--rsd-component-header-nav-menulist-background-color);
  min-width: 12rem;
  border-radius: 0.5rem;
  padding: var(--gafaelfawr-user-menu-padding);
  box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35),
    0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
`;
var MenuLink = styled5(RadixNavigationMenu.Link)`
  /* The styling on the menu triggers is overriding this colour. Need to re-address. */
  color: var(--rsd-component-header-nav-menulist-text-color) !important;
  border-radius: 0.5rem;
  padding: calc(var(--gafaelfawr-user-menu-padding) / 2)
    var(--gafaelfawr-user-menu-padding);
  margin: calc(var(--gafaelfawr-user-menu-padding) / -2);
  margin-bottom: calc(var(--gafaelfawr-user-menu-padding) / 2);

  &:last-of-type {
    margin-bottom: 0;
  }

  outline: 1px solid transparent;

  &:focus {
    outline: 1px solid
      var(--rsd-component-header-nav-menulist-selected-background-color);
  }

  &:hover {
    background-color: var(
      --rsd-component-header-nav-menulist-selected-background-color
    );
    color: white !important;
  }
`;
var ContentViewport = styled5(RadixNavigationMenu.Viewport)`
  /* This pushes the menu leftward to stay on the page.
     It's a magic number. Perhaps we can use the pushover API to
     position the menu more accurately?
  */
  position: relative;
  top: 0.5rem;
  right: 40%;
  height: var(--radix-navigation-menu-viewport-height);
  width: var(--radix-navigation-menu-viewport-width);
`;
var ViewportContainer = styled5.div`
  position: absolute;
  z-index: 1000;
`;
var Menu_default2 = Menu2;

// src/components/GafaelfawrUserMenu/GafaelfawrUserMenu.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var GafaelfawrUserMenu = ({
  children,
  currentUrl
}) => {
  const { user, isLoggedIn } = useGafaelfawrUser_default();
  const logoutUrl = getLogoutUrl2(currentUrl);
  const loginUrl = getLoginUrl2(currentUrl);
  if (isLoggedIn && user) {
    return /* @__PURE__ */ jsx6(Menu_default2, { logoutHref: logoutUrl, username: user.username, children });
  } else {
    return /* @__PURE__ */ jsx6(SiteNavLink2, { href: loginUrl, children: "Log in / Sign up" });
  }
};
var SiteNavLink2 = styled6.a`
  color: var(--rsd-component-header-nav-text-color);

  &:hover {
    color: var(--rsd-component-header-nav-text-hover-color);
  }
`;
GafaelfawrUserMenu.Link = MenuLink;
var GafaelfawrUserMenu_default = GafaelfawrUserMenu;

// src/components/IconPill/IconPill.tsx
import styled7 from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
var PillContainer = styled7.span`
  display: inline-block;
  padding: var(--sqo-space-xxxs) var(--sqo-space-unit);
  border: 1px solid transparent;
  border-radius: var(--sqo-border-radius-2);
  color: ${(props) => props.textColor};
  background-color: ${(props) => props.backgroundColor};
  font-size: 0.9rem;
  font-weight: 700;
  transition: var(--sqo-transition-basic);
  box-shadow: var(--sqo-elevation-sm);

  a {
    text-decoration: none;
    color: inherit;
  }

  &:hover {
    background-color: ${(props) => props.hoverBackgroundColor};
    box-shadow: var(--sqo-elevation-lg);
  }
`;
var StyledFontAwesomeIcon = styled7(FontAwesomeIcon)`
  display: inline-block;
  margin-right: 0.4em;
  font-size: 0.9em;
`;
var IconPill = ({
  icon,
  text,
  url,
  backgroundColor = "var(--sqo-primary-button-background-color)",
  hoverBackgroundColor = "var(--sqo-primary-button-background-color-hover)",
  textColor = "#ffffff"
}) => {
  return /* @__PURE__ */ jsx7(
    PillContainer,
    {
      textColor,
      backgroundColor,
      hoverBackgroundColor,
      children: /* @__PURE__ */ jsxs3("a", { href: url, children: [
        /* @__PURE__ */ jsx7(StyledFontAwesomeIcon, { icon }),
        text
      ] })
    }
  );
};
var IconPill_default = IconPill;

// src/components/PrimaryNavigation/PrimaryNavigation.tsx
import { forwardRef, useEffect, useRef } from "react";
import styled8 from "styled-components";
import * as RadixNavigationMenu2 from "@radix-ui/react-navigation-menu";

// src/components/PrimaryNavigation/utils.ts
function mergeReferences(references) {
  return (value) => {
    for (const reference of references) {
      if (typeof reference === "function") {
        reference(value);
      } else if (reference != null) {
        reference.current = value;
      }
    }
  };
}

// src/components/PrimaryNavigation/PrimaryNavigation.tsx
import { jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var PrimaryNavigation = forwardRef(
  (_a, reference) => {
    var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
    const containerReference = useRef(null);
    useEffect(() => {
      const container = containerReference.current;
      if (!container)
        return;
      const updatePosition = (item) => {
        const menuItemRect = item.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const topOffset = menuItemRect.top - containerRect.top;
        container.style.setProperty(
          "--radix-navigation-menu-item-active-top",
          `${topOffset}px`
        );
        if (containerRect.right - menuItemRect.right < 150) {
          container.style.setProperty(
            "--radix-navigation-menu-item-active-left",
            "unset"
          );
          container.style.setProperty(
            "--radix-navigation-menu-item-active-right",
            "0px"
          );
        } else {
          container.style.setProperty(
            "--radix-navigation-menu-item-active-left",
            `${menuItemRect.left - containerRect.left}px`
          );
          container.style.setProperty(
            "--radix-navigation-menu-item-active-right",
            "unset"
          );
        }
      };
      const mutationCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "attributes" && mutation.attributeName === "data-state" && mutation.target instanceof HTMLElement && mutation.target.hasAttribute("aria-expanded") && mutation.target.dataset.state === "open") {
            updatePosition(mutation.target);
          }
        }
      };
      const observer = new MutationObserver(mutationCallback);
      observer.observe(container, {
        childList: true,
        attributes: true,
        subtree: true
      });
      return () => {
        observer.disconnect();
      };
    }, []);
    return /* @__PURE__ */ jsxs4(
      Root4,
      __spreadProps(__spreadValues({
        ref: mergeReferences([reference, containerReference])
      }, props), {
        className,
        children: [
          /* @__PURE__ */ jsx8(ItemList, { children }),
          /* @__PURE__ */ jsx8(NavigationMenuViewport, {})
        ]
      })
    );
  }
);
PrimaryNavigation.displayName = "PrimaryNavigation";
var Root4 = styled8(RadixNavigationMenu2.Root)`
  position: relative;
`;
var ItemList = styled8(RadixNavigationMenu2.List)`
  list-style: none;
  margin-bottom: 0;
  padding: 0;
  display: flex;
  justify-self: end;
  width: 100%;
  font-size: 1.2rem;
`;
var Item3 = styled8(RadixNavigationMenu2.Item)`
  margin: 0 1em;
`;
var TriggerLink = styled8(RadixNavigationMenu2.Link)`
  color: var(--rsd-component-header-nav-text-color);
  border: none;
  border-radius: 0.5rem;
  padding: 2px 4px;
  display: inline-block; // For consistency with MenuTrigger button
  /* padding: 0; */

  &:hover {
    color: var(--rsd-component-header-nav-text-hover-color);
  }

  &:focus {
    outline: 1px solid var(--rsd-color-primary-500);
  }
`;
var Trigger4 = ({ children }) => {
  return /* @__PURE__ */ jsx8(
    StyledTrigger,
    {
      onPointerMove: (event) => event.preventDefault(),
      onPointerEnter: (event) => event.preventDefault(),
      onPointerLeave: (event) => event.preventDefault(),
      children
    }
  );
};
var StyledTrigger = styled8(RadixNavigationMenu2.Trigger)`
  color: var(--rsd-component-header-nav-text-color);
  padding: 2px 4px;
  /* padding: 0; */

  // Reset button styles
  background-color: transparent;
  border: none;
  border-radius: 0.5rem;

  &:focus {
    outline: 1px solid var(--rsd-color-primary-500);
  }

  &:hover {
    color: var(--rsd-component-header-nav-text-hover-color);
    cursor: pointer;
  }

  svg {
    display: inline-block;
    width: 1rem;
    height: 1rem;
    vertical-align: middle;
  }

  &[data-state='open'] {
    svg {
      transform: rotate(180deg);
    }
  }
`;
var Content4 = ({ children }) => {
  return /* @__PURE__ */ jsx8(
    StyledContent2,
    {
      onPointerMove: (event) => event.preventDefault(),
      onPointerEnter: (event) => event.preventDefault(),
      onPointerLeave: (event) => event.preventDefault(),
      children
    }
  );
};
var StyledContent2 = styled8(RadixNavigationMenu2.Content)`
  /* This unit for the padding is also the basis for the spacing and
   * sizing of the menu items.
  */
  --gafaelfawr-user-menu-padding: 0.5rem;

  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  list-style: none;

  font-size: 1rem;
  background-color: var(--rsd-component-header-nav-menulist-background-color);
  min-width: 12rem;
  border-radius: 0.5rem;
  padding: var(--gafaelfawr-user-menu-padding);
  padding-right: 0; // to avoid double padding on the right side with MenuLink
  box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35),
    0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
`;
var ContentItem = styled8(RadixNavigationMenu2.Item)`
  display: flex;
`;
var Link3 = styled8(RadixNavigationMenu2.Link)`
  /* The styling on the menu triggers is overriding this colour. Need to re-address. */
  border-radius: 0.5rem;
  padding: calc(var(--gafaelfawr-user-menu-padding) / 2)
    var(--gafaelfawr-user-menu-padding);
  margin: calc(var(--gafaelfawr-user-menu-padding) / -2);
  margin-bottom: calc(var(--gafaelfawr-user-menu-padding) / 2);
  width: 100%;

  color: var(--rsd-component-header-nav-menulist-text-color);

  &:last-of-type {
    margin-bottom: 0;
  }

  outline: 1px solid transparent;

  &:focus {
    outline: 1px solid
      var(--rsd-component-header-nav-menulist-selected-background-color);
  }

  &:hover {
    background-color: var(
      --rsd-component-header-nav-menulist-selected-background-color
    );
    color: white !important;
  }
`;
var NavigationMenuViewport = forwardRef((_a, reference) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx8(NavigationMenuViewportContainer, { children: /* @__PURE__ */ jsx8(
    NavigationMenuStyledViewport,
    __spreadValues({
      className,
      ref: reference,
      onPointerEnter: (event) => event.preventDefault(),
      onPointerLeave: (event) => event.preventDefault()
    }, props)
  ) });
});
NavigationMenuViewport.displayName = RadixNavigationMenu2.Viewport.displayName;
var NavigationMenuViewportContainer = styled8.div`
  position: absolute;
  z-index: 1000; // Ensure the menu is above other content
  left: var(--radix-navigation-menu-item-active-left);
  right: var(--radix-navigation-menu-item-active-right);
  top: 100%;
  display: flex;
  /* transform: translateX(var(--radix-navigation-menu-item-active-left)); */
  justify-content: center;
  transition: transform 100ms;
`;
var NavigationMenuStyledViewport = styled8(RadixNavigationMenu2.Viewport)`
  position: relative;
  margin-top: 0.375rem;
  transform-origin: top center;
  height: var(--radix-navigation-menu-viewport-height);
  width: 100%;
  overflow: hidden;
  border-radius: 0.375rem;
  border: 1px solid var(--border);
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  background-color: white;
  color: black;

  @media (min-width: 768px) {
    width: var(--radix-navigation-menu-viewport-width);
  }

  &[data-state='open'] {
    animation: menuIn 200ms ease;
  }

  &[data-state='closed'] {
    animation: menuOut 200ms ease;
  }

  @keyframes menuIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes menuOut {
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      opacity: 0;
      transform: scale(0.95);
    }
  }
`;
PrimaryNavigation.Item = Item3;
PrimaryNavigation.Trigger = Trigger4;
PrimaryNavigation.TriggerLink = TriggerLink;
PrimaryNavigation.Content = Content4;
PrimaryNavigation.ContentItem = ContentItem;
PrimaryNavigation.Link = Link3;
var PrimaryNavigation_default = PrimaryNavigation;

// src/hooks/useCurrentUrl.ts
import { useRouter } from "next/router";
function useCurrentUrl(baseUrl) {
  const router = useRouter();
  return new URL(router.pathname, baseUrl);
}
var useCurrentUrl_default = useCurrentUrl;
export {
  Button,
  GafaelfawrUserDropdown_default as GafaelfawrUserDropdown,
  GafaelfawrUserMenu_default as GafaelfawrUserMenu,
  IconPill_default as IconPill,
  PrimaryNavigation_default as PrimaryNavigation,
  getLoginUrl2 as getLoginUrl,
  getLogoutUrl2 as getLogoutUrl,
  useCurrentUrl_default as useCurrentUrl,
  useGafaelfawrUser_default as useGafaelfawrUser
};
